import { RouterConfigOptions } from '@angular/router';

/**
 * WAM-773 — the app-wide router options (main.ts passes them to `provideRouter` via
 * `withRouterConfig`; specs that need the real behaviour reuse the same object).
 *
 * `canceledNavigationResolution: 'computed'`: when a `canDeactivate` guard refuses a browser
 * back/forward (popstate) navigation, the router puts the browser back by `history.go(delta)`
 * instead of Angular's default `'replace'`, which calls `replaceState` on the entry the browser has
 * ALREADY moved to — overwriting that history entry with the current URL, so a later "back" skips
 * it. The AU builder and pointer editor (`auUnsavedChangesGuard`) refuse and rely on this. The
 * directory institution/program pages' `canDeactivate` saves on leave and never refuses (it resolves
 * true, or never resolves if the save fails); they are covered for a superseded pending guard.
 */
export const APP_ROUTER_CONFIG: RouterConfigOptions = {
  canceledNavigationResolution: 'computed',
};
